import React from 'react';
import {
  ActivityIndicator, StyleSheet, Text, View,
} from 'react-native';
import UpArrow from '../../../components/UpArrow';
import Colors from '../../../constants/Colors';
import MonitorIcon from '../../../components/MonitorIcon';
import DeskIcon24 from '../../../components/24pxIcons/DeskIcon24';
import BinIcon24 from '../../../components/24pxIcons/BinIcon24';
import CoffeeMachine24 from '../../../components/24pxIcons/CoffeeMachine24';
import HygieneIcon24 from '../../../components/24pxIcons/HygieneIcon24';
import InternetIcon24 from '../../../components/24pxIcons/InternetIcon24';
import MeetingRoom24 from '../../../components/24pxIcons/MeetingRoom24';
import PrinterIcon24 from '../../../components/24pxIcons/PrinterIcon24';

export default function ButtonTile({
  title,
  value,
  compareValue,
  change,
  isMobile,
  compareStart,
  loading,
  testID,
}: {
  title: string,
  value: number,
  compareValue: number,
  change: number,
  isMobile: boolean,
  compareStart: any,
  loading?: boolean,
  testID?: number,
}) {
  const getIcon = (category: string) => {
    switch (category) {
      case 'Equipment':
        return <MonitorIcon color={Colors.light.hereworksBlue400} />;
      case 'Desks':
        return <DeskIcon24 />;
      case 'Toilet':
        return <HygieneIcon24 />;
      case 'Printer':
        return <PrinterIcon24 />;
      case 'Coffee machine':
        return <CoffeeMachine24 />;
      case 'Internet':
        return <InternetIcon24 />;
      case 'Meeting room':
        return <MeetingRoom24 />;
      case 'Bin':
        return <BinIcon24 />;
      default:
        return <MeetingRoom24 />;
    }
  };

  function getChangeColor(changeValue: number) {
    if (changeValue === 0) {
      return Colors.light.hereworksBlack400;
    }
    return changeValue < 0 ? Colors.light.hereworksCheckGreen : Colors.light.hereworksCoral;
  }

  function getTestID(testKey: number) {
    switch (testKey) {
      case 0: return 'sa-first-template-card';
      case 1: return 'sa-second-template-card';
      case 2: return 'sa-third-template-card';
      default: return `sa-${testKey}-template-card`;
    }
  }

  return (
    <View
      style={[
        styles.tile,
        { marginEnd: isMobile ? 8 : 12 },
      ]}
      testID={getTestID(testID)}
    >
      <View
        style={{
          flexDirection: 'row',
          marginTop: 8,
          marginLeft: isMobile ? 8 : 16,
          alignItems: 'center',
        }}
      >
        {getIcon(title?.trim())}
        <Text
          style={styles.tileTitle}
        >
          {title}
        </Text>
      </View>
      <View style={{ flexDirection: 'row' }}>
        <Text
          style={[styles.tileValue, {
            marginHorizontal: isMobile ? 8 : 10,
          }]}
        >
          {loading ? '-' : value}
        </Text>
        {loading ? <ActivityIndicator size={'large'} color={Colors.light.hereworksLoading} /> : <></>}
        {compareStart !== null && (
          <Text
            style={[styles.tileValue, {
              color: Colors.light.hereworksYellow600,
              marginLeft: isMobile ? 3 : 0,
            }]}
          >
            {compareValue}
          </Text>
        )}
      </View>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          marginHorizontal: isMobile ? 8 : 16,
          marginBottom: 8,
        }}
      >
        {change !== 0 && (
          <UpArrow
            color={change < 0 ? Colors.light.hereworksCheckGreen : Colors.light.hereworksCoral}
            style={
              change < 0
                ? { transform: [{ rotateZ: '180deg' }] }
                : { transform: [{ rotateZ: '0deg' }] }
            }
          />
        )}
        <Text
          style={[styles.changeText, {
            color: getChangeColor(change),
          }]}
        >
          {change === 0 && '~'}
          {`${Math.abs(change)}%`}
        </Text>
        <Text style={styles.fromYesterday}>{'from previous range'}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  tileTitle: {
    color: Colors.light.hereworksPrimaryGrey,
    marginHorizontal: 8,
    marginVertical: 9,
    fontSize: 14,
    fontFamily: 'Roboto_400Regular',
  },
  tile: {
    borderRadius: 10,
    backgroundColor: '#fff',
    alignSelf: 'flex-start',
    borderWidth: 1,
    borderColor: Colors.light.hereworksWhite300,
  },
  fromYesterday: {
    color: Colors.light.hereworksPrimaryGrey,
    marginVertical: 8,
    marginRight: 8,
    fontSize: 14,
    fontFamily: 'Roboto_400Regular',
  },
  tileValue: {
    marginVertical: 4,
    marginBottom: 8,
    fontFamily: 'Poppins_600SemiBold',
    fontSize: 48,
    color: Colors.light.hereworksBlack600,
  },
  changeText: {
    marginVertical: 8,
    marginRight: 4,
    marginLeft: 2,
    fontSize: 14,
    fontFamily: 'Roboto_400Regular',
  },
});
